import React from 'react';
import './FormField.css';
interface FormFieldProps {
  label: string;
  required?: boolean;
  error?: string;
  children: React.ReactNode;
  className?: string;
  helpText?: string | React.ReactNode;
}
const FormField: React.FC<FormFieldProps> = ({ 
  label, 
  required = false, 
  error, 
  children, 
  className = '',
  helpText 
}) => {
  return (
    <div className={`form-field ${className}`}>
      <label className="form-field-label">
        {label}
        {required && <span className="required-asterisk">*</span>}
      </label>
      {helpText && <p className="form-field-help">{helpText}</p>}
      {children}
      {error && <span className="form-field-error">{error}</span>}
    </div>
  );
};
export default FormField;